enum Action {
  CLOSE_CHAT = 'closeChat',
  OPEN_CHAT = 'openChat',
  SET_HAS_NEW_CHAT_MESSAGE = 'setHasNewChatMessage',
  START_PUNCH_TIME = 'startPunchTime',
}

export default Action;
